export interface Configuration {
    readonly apiUrl: string;
}

declare global {
    interface Window {
        ENV?: {API_URL?: string};
    }
}

export const configuration: Configuration = {
    apiUrl: window.ENV?.API_URL ?? process.env.REACT_APP_API_URL ?? "http://api.management.local:30701",
};
